module.exports = __webpack_public_path__ + "static/media/rodape-logo-speedy.240deb72.png";